import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectClientLabelColor = (store: StoreSchema) =>
	store.newClientLabel.clientLabel.labelColor